import axios from 'axios'

//
// api/roads.js
//
export default {
    /**
     * getRoad
     * Gets a road object by its A number, ie the A11 is number 11.
     */
    getRoad(number) {
        return axios.get(
            //'/api/road/get/' + number + '?light=1'
            '/data/roads/json/' + number + ".json"
        ).then((response) => {
            //return response.data.result ? response.data.result : false
            return response.data
        });
    },
}